/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobEngineTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TemplateJobEngineTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return TemplateJobEngineTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobEngineTypeQueryOperator>): TemplateJobEngineTypeQueryOperator {
        let obj = Object.assign(new TemplateJobEngineTypeQueryOperator(), model);
        TemplateJobEngineTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobEngineTypeQueryOperator>): TemplateJobEngineTypeQueryOperator {
        if (!model) return null;
        return TemplateJobEngineTypeQueryOperator.newInstance(<TemplateJobEngineTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobEngineTypeQueryOperator) {
        if (!obj) return;

        models.TemplateJobEngineTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobEngineTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateJobEngineTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template job execution engine types to include (maps to the job's internal `type` field)
     */
    engine_types: Array<models.TemplateEngineType>;

}
